// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E1Mz","top":"styles_top__3YGR1"};